import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // 1. Redux Hooks
import { firebase } from '../../utilities';
import { auth } from '../../Auth';
import { TYPES } from '../reducer'; // 2. Action Types
import { Timestamp } from 'firebase/firestore'


export default function SiteNote({ logger, noteKey, save }) {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(false);

  // 3. Select the specific note based on the index passed from parent
  // We use optional chaining (?.) just in case the array is temporarily empty
  const note = useSelector(state => state.project.siteNotes?.[noteKey]);
  const userIndex = useSelector(state => state.project.user_index);

  // Safety check if note is undefined (e.g. during a delete operation)
  if (!note) return null;

  function change(e) {
    // Clone the note to avoid mutating Redux state directly before dispatch
    const updatedNote = { ...note };

    if (e.target.type === 'checkbox') {
      if (e.target.checked) {
        logger.event(
          `${auth.currentUser.displayName} attempted to contact the site`, 
          null, 
          5, 
          userIndex
        );
      }
      updatedNote.contactAttempted = e.target.checked;
    } else {
      updatedNote.note = e.target.value;
    }

    // 4. Dispatch Change Action
    dispatch({ 
      type: TYPES.CHANGE_NOTE, 
      payload: { index: noteKey, value: updatedNote } 
    });
  }

  const created =
    Object.prototype.toString.call(note.created) === '[object Date]'
      ? new Timestamp.fromDate(note.created)
      : new Timestamp(note.created._seconds, note.created._nanoseconds);

  return (
    <div className="flex-column" onBlur={save}>
      <div className="flex-row align-center">
        <div className="bold">{created.toDate().toDateString()}</div>
        <div className="padding-left-1">{note.author ? note.author : '[Unknown]'}</div>
        <div className="padding-left-right-1">Contact Attempted</div>
        <input
          disabled={note.authorId !== auth.currentUser.uid}
          onChange={change} // Simplified handler
          type="checkbox"
          name="contactAttempt"
          checked={!!note.contactAttempted} // Force boolean
          value="contact_attempted"
          className="padding-left-1"
        />
      </div>
      <div onClick={() => setSelected(!selected)}>
        {note.authorId !== auth.currentUser.uid || !selected ? (
          <div className="padding-1 italic">{note.note || '(Click to Edit)'}</div>
        ) : (
          <div className="flex-row align-center">
            <textarea
              onBlur={() => setSelected(false)}
              onClick={(e) => e.stopPropagation()}
              rows="2"
              cols="75"
              value={note.note}
              onChange={change} // Simplified handler
              className="padding-1"
            />
            <div className="padding-1 margin-2 background-tertiary color-white">Save</div>
          </div>
        )}
      </div>
    </div>
  );
}